import { DEFAULT_THEME } from "../store/modules/theme";

export const hexToRGB = (color: string): { red: number; green: number; blue: number } => {
  // Define a regular expression pattern for a valid hex color code
  const hexColorPattern = /^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

  //test color against regExp and if it's not valid select default
  const hex = hexColorPattern.test(color) ? color.replace(/^#/, "") : DEFAULT_THEME.accentColor.replace(/^#/, "");

  // Convert the hex color to RGB
  const red = parseInt(hex.slice(0, 2), 16);
  const green = parseInt(hex.slice(2, 4), 16);
  const blue = parseInt(hex.slice(4, 6), 16);

  return { red, green, blue };
};

export const getFactor = (percent: number): number => Math.min(100, Math.max(0, percent)) / 100;

export const RGBToHex = (red: number, green: number, blue: number): string => {
  // Convert the new RGB values to hex
  return `#${Math.round(red).toString(16).padStart(2, "0")}${Math.round(green).toString(16).padStart(2, "0")}${Math.round(blue)
    .toString(16)
    .padStart(2, "0")}`;
};

export const lightenColor = (color: string, percent: number): string => {
  const rgb = hexToRGB(color);
  const factor = getFactor(percent);

  const newR = Math.min(255, rgb.red + (255 - rgb.red) * factor);
  const newG = Math.min(255, rgb.green + (255 - rgb.green) * factor);
  const newB = Math.min(255, rgb.blue + (255 - rgb.blue) * factor);

  return RGBToHex(newR, newG, newB);
};

export const darkenColor = (color, percent) => {
  const rgb = hexToRGB(color);
  const factor = getFactor(percent);

  const newR = Math.max(0, rgb.red * (1 - factor));
  const newG = Math.max(0, rgb.green * (1 - factor));
  const newB = Math.max(0, rgb.blue * (1 - factor));

  return RGBToHex(newR, newG, newB);
};
